module.exports = __webpack_public_path__ + "static/media/icon_mapa_warning.e53bb8bf.svg";